/**
 * @flow
 * @format
 */

import React from 'react';
import _ from 'lodash/fp';
import cc from 'classcat';
import { Col } from 'reactstrap';

// import classes from './FieldTypeInput.scss';
import { branch, shallowEqual } from '~/utils';

import RevertInput from '../RevertInput';
import InputField from '../InputField';

import fieldWrapperClasses from '../FieldWrapper/FieldWrapper.scss';

type PropsType = {
  id: any,
  calculated: boolean,
  changed: boolean,
  changeInput: Function,
  defaultVal: number | string | null,
  error: string[],
  range: Array<number>,
  revertInput: Function,
  step: string,
  tooltip: string | ReactElementType,
  type: string,
  unit: ?string,
  value: number | string | null,
};

const SIZE = 12 - +process.env.REACT_APP_LEFT_PANE_SIZE;

// eslint-disable-next-line react/prefer-stateless-function
export class FieldTypeInput extends React.Component<PropsType, *> {
  static defaultProps = {
    range: [1, 2],
    error: [],
    tooltip: null,
  };

  shouldComponentUpdate(nextProps: PropsType) {
    const subProps = _.omit(['tooltip']);
    return !shallowEqual(subProps(this.props), subProps(nextProps));
  }

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const {
      error,
      defaultVal,
      value,
      changed,
      range,
      type,
      calculated,
      unit,
      step,
      revertInput,
      changeInput,
    } = this.props;
    const canRevert = changed || value !== defaultVal;

    const rangeDiv = (
      <button
        disabled
        className={cc(['btn', 'btn-link', 'btn-sm', 'disabled'])}
        style={{ cursor: 'inherit' }}
      >
        {`Range: [${range[0]}, ${range[1]}]`}
      </button>
    );

    const recommendedDiv = (
      <RevertInput
        value={defaultVal}
        enable={canRevert}
        onClick={revertInput}
      />
    );

    const errorDiv = (
      <div className={fieldWrapperClasses.errorBlock}>Error: {error}</div>
    );

    // const differs = defaultValue !== currentValue;
    const hasError = error.length > 0;
    const areAllNumbers = _.every(_.isNumber);
    const hasRange = areAllNumbers(range) && !calculated;

    // Input DateTime
    // https://stackoverflow.com/a/19012837
    // min=0 : only positive numbers
    // step any allows any number of decimal places

    return (
      <Col sm={SIZE}>
        <div className={fieldWrapperClasses.infoIconWrapper}>
          {this.props.tooltip}
        </div>
        <div className="d-flex">
          <InputField
            value={value}
            readOnly={calculated}
            type={type}
            step={step}
            onChange={changeInput}
            unit={unit}
          />
        </div>
        <div className={fieldWrapperClasses.inputGroupColumn}>
          <div className={fieldWrapperClasses.inputGroupStyle}>
            {branch(hasRange, rangeDiv)}
          </div>
          <div className={fieldWrapperClasses.inputGroupStyle}>
            {branch(!calculated, recommendedDiv)}
          </div>
        </div>
        {branch(hasError, errorDiv)}
      </Col>
    );
  }
}

export default FieldTypeInput;



// WEBPACK FOOTER //
// ./src/components/FieldTypeInput/FieldTypeInput.js